import React from "react";

export default ({ state }) => {
  if (state === "tipoCita") {
    return <div>Cancel footer option</div>;
  } else {
    return null;
  }
};
